"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { WHATS_NEW_ITEMS, WHATS_NEW_TITLE, WHATS_NEW_VERSION } from "./whatsNewContent";

const STORAGE_KEY = "whatsNewSeen";

// "Kaj je novega": shown once per visitor and version on the home page. Storage may be unavailable
// (private window), in which case the popup is simply not shown.
const WhatsNewPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (window.self !== window.top) return; // never inside the local-news embeds
      if (localStorage.getItem(STORAGE_KEY) !== WHATS_NEW_VERSION) setOpen(true);
    } catch {
      /* no storage: do not show */
    }
  }, []);

  const close = () => {
    setOpen(false);
    try {
      localStorage.setItem(STORAGE_KEY, WHATS_NEW_VERSION);
    } catch {
      /* ignore */
    }
  };

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && close();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[10001] flex items-center justify-center bg-[#000000B3] px-3"
      onMouseDown={(e) => e.target === e.currentTarget && close()}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={WHATS_NEW_TITLE}
        className="max-h-[90vh] w-full max-w-[520px] overflow-y-auto rounded-[16px] bg-[#E8EEF5] p-6 shadow-lg"
      >
        <div className="flex items-start justify-between gap-4">
          <h2 className="text-[28px] leading-[34px] text-[#1E2125]">{WHATS_NEW_TITLE}</h2>
          <button type="button" onClick={close} aria-label="Zapri" className="text-[28px] leading-none text-[#6D778E]">
            ×
          </button>
        </div>
        <ul className="mt-5 flex flex-col gap-4">
          {WHATS_NEW_ITEMS.map((item) => (
            <li key={item.title}>
              <h3 className="text-[18px] leading-[24px] text-[#14105F]">{item.title}</h3>
              <p className="mt-1 text-[15px] leading-[22px] text-[#3C3E41]">{item.text}</p>
            </li>
          ))}
        </ul>
        <div className="mt-6 flex items-center justify-between gap-4">
          <Link href="/posodobitve" onClick={close} className="text-[15px] text-[#0A85C2] underline">
            Vse novosti in izboljšave
          </Link>
          <button
            type="button"
            onClick={close}
            className="h-[44px] rounded-[6px] border border-[#0A85C2] bg-white px-6 text-[16px] text-[#1E2125]"
          >
            V redu
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewPopup;
